import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

let cachedNative: boolean | null = null;
let cachedAny: boolean | null = null;

export async function isNativeIOS(): Promise<boolean> {
  if (cachedNative !== null) return cachedNative;
  if (!Capacitor.isNativePlatform()) return (cachedNative = false);
  try {
    const info = await Device.getInfo();     // returns 'ios' for iPhone & iPadOS
    return (cachedNative = info.platform === 'ios');
  } catch {
    const ua = (globalThis.navigator?.userAgent || '').toLowerCase();
    return (cachedNative = /iphone|ipad|ipod/.test(ua));
  }
}

// Detect iOS (both native app and web browser)
export function isIOS(): boolean {
  if (cachedAny !== null) return cachedAny;
  
  // Check if it's iOS (works for Safari, Chrome, etc. on iOS)
  const ua = (globalThis.navigator?.userAgent || '').toLowerCase();
  const isIOSDevice = /iphone|ipad|ipod/.test(ua);
  
  // Additional check for iOS Safari/Chrome specific patterns
  const isIOSBrowser = /like mac os x/.test(ua) && (/iphone|ipad|ipod/.test(ua));
  
  return (cachedAny = isIOSDevice || isIOSBrowser);
}